import m, {Vnode} from "mithril";
import ICustomForm from "../../ICustomForm";
import CFNumber from "../CFNumber";
import ICustomFormSettings from "../../ICustomFormSettings";
import ScrollItem from "../../shared/components/HorizontalScrollPicker/ScrollItem";
import HorizontalScrollPicker from "../../shared/components/HorizontalScrollPicker/HorizontalScrollPicker";

export default class NumberRange extends CFNumber implements ICustomForm
{
    private readonly picker: HorizontalScrollPicker;
    private value: null|number;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        this.value = isNaN(Number(this.textboxItem.getVariable())) ? null : Number(this.textboxItem.getVariable());

        const min = Number(this.textboxItem.childrenTags[0].attributes['rangeMin']);
        const max = Number(this.textboxItem.childrenTags[0].attributes['rangeMax']);

        const items: ScrollItem[] = [];
        for (let i = min; i<=max; i++) {
            items.push( new ScrollItem(''+i, ''+i) );
        }

        this.picker = new HorizontalScrollPicker(
            items,
            this.numberInputCell,
            this.getVariable(this.variableName),
            this.onSelect.bind(this),
            this.onScrollOver.bind(this)
        );
    }


    checkRequirements(): boolean {
        if (!this.textboxItem.childrenTags[0].attributes['rangeMin']) {
            console.log('customForm-Number-range: Missing rangeMin for text input');
            return false;
        }

        if (!this.textboxItem.childrenTags[0].attributes['rangeMax']) {
            console.log('customForm-Number-range: Missing rangeMax for text input');
            return false;
        }

        return super.checkRequirements();
    }

    private onSelect(item: ScrollItem) {
        this.setVariable(this.variableName, item.value);
    }

    private onScrollOver(item: ScrollItem) {
        this.value = Number(item.value);
    }

    public view() {
        const form = this.settings.form;
        const questionary = form.questionary;

        return this.viewLayout([
            m('.picture', {}, m('.value-'+this.value)),
            this.viewPicker(),
            m('p.hint', {}, questionary.renderText(questionary.messages.get('swipeToSelectNumber'))),
            m('.', {}, this.checkboxes.map(cell => m(cell))),
        ]);
    }

    private viewPicker(): Vnode {
        return m(this.picker);
    }
}